import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useFeatureFlag } from '../_hooks/useFeatureFlag';
import { selectPortalName, showStartPageSelector } from '../AdviserArea/AdviserAreaSelector';
import { Box } from '../CommonComponents/OPL/Box/Box';
import { Modal } from '../CommonComponents/OPL/Modal/Modal';
import { Feature } from '../CommonSelectors/CommonArea.types';
import { Welcome } from './components/Welcome/Welcome';
import { NonRedtailWelcome } from './components/NonRedtailWelcome/NonRedtailWelcome';

const onNavigateAway = () => {
  ADV.util.showAdviserAreaEmptyState(false);
  ADV.util.Router.go2('ClientSearch');
};

export const AdviserGetStarted = () => {
  const showStandalone = useFeatureFlag(Feature.Standalone);
  const isRedtail = useFeatureFlag(Feature.Redtail);
  const showStartPage = useSelector(showStartPageSelector);

  const portalName = useSelector(selectPortalName);
  document.title = `Welcome | ${portalName}`;

  useEffect(() => {
    const helper = ADV.util.setHelp(ADV.HelpDescriptors.GetStarted);

    return () => {
      ADV.util.unsetHelp(helper);
    };
  }, []);

  if (!(showStandalone && showStartPage)) {
    onNavigateAway();

    return null;
  }

  const onClose = () => {
    onNavigateAway();
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      height="100%"
      css={{ maxWidth: 1200 }}
      m="auto"
    >
      <Modal
        isOpen
        onRequestClose={() => {
          onClose();
        }}
        aria={{ labelledby: 'modal-header' }}
        size="medium"
      >
        {isRedtail ? <Welcome onClose={onClose} /> : <NonRedtailWelcome onClose={onClose} />}
      </Modal>
    </Box>
  );
};
